import type { Decoder } from 'io-ts/Decoder';
import { nullable, number, string, struct } from 'io-ts/Decoder';
import type { PushSubscription as BaseSubscriptionDetails } from 'web-push';

type PushSubscriptionDetails = BaseSubscriptionDetails & {
	// https://developer.mozilla.org/en-US/docs/Web/API/PushSubscription/expirationTime
	expirationTime: number | null;
};

/**
 * Configuration for a Push Subscription. This can be obtained on the frontend by calling
 * serviceWorkerRegistration.pushManager.subscribe().
 * The expected format is the same output as JSON.stringify'ing a PushSubscription in the browser.
 * @see node_modules/@types/web-push/index.d.ts
 */
export const Details: Decoder<unknown, PushSubscriptionDetails> = struct({
	endpoint: string,
	keys: struct({
		p256dh: string,
		auth: string,
	}),
	expirationTime: nullable(number),
});
